import { all } from 'redux-saga/effects';
import { getAsyncSagas } from 'react-async-client';

import error from './error';
import appRun from './appRun';
import locationChange from './locationChange';
import login from './login';
import pushNotifications from './pushNotifications';
import user from './user';
import language from './language';
import links from './links';

import addRequest from './addRequest';
import * as approvals from './approvals';

import { request, approvalPerson, approvalProject, project, worksheet, notdone, projectMass, worksheetMass } from './tables';
import { projectSettings, worksheetSettings, projectMassSettings, worksheetMassSettings } from './settings';

import menu from './menu';
import collapsibleModal from './collapsibleModal';
import documentModal from './documentModal';

export default function* rootSaga() {
    yield all([
        ...getAsyncSagas(),

        error(),
        appRun(),
        locationChange(),
        login(),
        pushNotifications(),
        user(),
        language(),
        menu(),
        links(),

        addRequest(),
        request(),
        approvals.request(),
        approvalPerson(),
        approvals.approvalPerson(),
        approvalProject(),
        approvals.approvalProject(),

        project(),
        projectSettings(),
        worksheet(),
        worksheetSettings(),

        notdone(),

        projectMass(),
        projectMassSettings(),

        worksheetMass(),
        worksheetMassSettings(),

        collapsibleModal(),
        documentModal()
    ]);
}
